import {createApi} from '@reduxjs/toolkit/query/react';
import {generateAppHeaders} from '~/common/checkout/utils/app';
import {customBaseQuery} from '~/common/rtk-query/queries';

export const api = createApi({
  reducerPath: 'checkout',
  baseQuery: customBaseQuery({
    basePath: '/ajax/cart',
    headers: generateAppHeaders(),
  }),
  tagTypes: ['Cart', 'Packages', 'Event'],
  endpoints: () => ({}),
});
